import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        browse: 'Browse',
        search: 'Search',
        channel: 'The Movie Matrix TV YouTube Channel',
        past: 'The Past',
        present: 'The Present',
        future: 'The Future',
      },
      eras: {
        pastTitle: 'The Past',
        pastSubtitle: 'Silent films through the 1970s',
        presentTitle: 'The Present',
        presentSubtitle: 'The 80s through today\'s latest releases',
        futureTitle: 'The Future',
        futureSubtitle: 'Upcoming trailers and "Coming Soon" teasers',
      },
      home: {
        slogan: 'The Past, Present, and Future of Film',
        watchTrailer: 'Watch Trailer',
        randomTrailer: 'Random Trailer',
        trendingTitle: 'Trending This Week',
        trendingSubtitle: "The hottest trailers everyone's watching",
        popularTitle: 'All-Time Favorites',
        popularSubtitle: 'Classic trailers that never get old',
        loading: 'Loading trailers...',
      },
      browse: {
        title: 'Browse Trailers',
        subtitle: 'Filter by genre, year, and popularity',
        filters: 'Filters',
        genre: 'Genre',
        year: 'Year',
        sortBy: 'Sort By',
        allGenres: 'All Genres',
        allYears: 'All Years',
        mostPopular: 'Most Popular',
        leastPopular: 'Least Popular',
        highestRated: 'Highest Rated',
        lowestRated: 'Lowest Rated',
        newest: 'Newest',
        oldest: 'Oldest',
        resetFilters: 'Reset Filters',
        loading: 'Loading movies...',
        noMovies: 'No movies found with these filters',
        previous: 'Previous',
        next: 'Next',
        page: 'Page',
      },
      search: {
        title: 'Search Trailers',
        subtitle: 'Find any movie trailer from any era',
        placeholder: 'Search for a movie...',
        searchButton: 'Search',
        searching: 'Searching...',
        resultsFor: 'Found {{count}} results for "{{query}}"',
        noResults: 'No movies found for "{{query}}"',
        tryDifferent: 'Try searching with different keywords',
        startSearching: 'Start searching to discover trailers',
      },
      movie: {
        loading: 'Loading movie details...',
        notFound: 'Movie not found',
        overview: 'Overview',
        watchTrailer: 'Watch Trailer',
        moreTrailers: 'More Trailers',
        rating: 'Rating',
        year: 'Year',
        runtime: 'min',
      },
    },
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        browse: 'Explorar',
        search: 'Buscar',
        channel: 'Canal de YouTube The Movie Matrix TV',
        past: 'El Pasado',
        present: 'El Presente',
        future: 'El Futuro',
      },
      eras: {
        pastTitle: 'El Pasado',
        pastSubtitle: 'Cine mudo hasta los años 70',
        presentTitle: 'El Presente',
        presentSubtitle: 'Desde los 80 hasta los estrenos de hoy',
        futureTitle: 'El Futuro',
        futureSubtitle: 'Próximos tráilers y avances de "Proximamente"',
      },
      home: {
        slogan: 'El Pasado, Presente y Futuro del Cine',
        watchTrailer: 'Ver Tráiler',
        randomTrailer: 'Tráiler Aleatorio',
        trendingTitle: 'Tendencias de la Semana',
        trendingSubtitle: 'Los tráilers más populares que todos están viendo',
        popularTitle: 'Favoritos de Todos los Tiempos',
        popularSubtitle: 'Tráilers clásicos que nunca envejecen',
        loading: 'Cargando tráilers...',
      },
      browse: {
        title: 'Explorar Tráilers',
        subtitle: 'Filtrar por género, año y popularidad',
        filters: 'Filtros',
        genre: 'Género',
        year: 'Año',
        sortBy: 'Ordenar Por',
        allGenres: 'Todos los Géneros',
        allYears: 'Todos los Años',
        mostPopular: 'Más Popular',
        leastPopular: 'Menos Popular',
        highestRated: 'Mejor Calificado',
        lowestRated: 'Peor Calificado',
        newest: 'Más Reciente',
        oldest: 'Más Antiguo',
        resetFilters: 'Restablecer Filtros',
        loading: 'Cargando películas...',
        noMovies: 'No se encontraron películas con estos filtros',
        previous: 'Anterior',
        next: 'Siguiente',
        page: 'Página',
      },
      search: {
        title: 'Buscar Tráilers',
        subtitle: 'Encuentra cualquier tráiler de cualquier época',
        placeholder: 'Buscar una película...',
        searchButton: 'Buscar',
        searching: 'Buscando...',
        resultsFor: '{{count}} resultados para "{{query}}"',
        noResults: 'No se encontraron películas para "{{query}}"',
        tryDifferent: 'Intenta buscar con diferentes palabras clave',
        startSearching: 'Comienza a buscar para descubrir tráilers',
      },
      movie: {
        loading: 'Cargando detalles de la película...',
        notFound: 'Película no encontrada',
        overview: 'Sinopsis',
        watchTrailer: 'Ver Tráiler',
        moreTrailers: 'Más Tráilers',
        rating: 'Calificación',
        year: 'Año',
        runtime: 'min',
      },
    },
  },
  pt: {
    translation: {
      nav: {
        home: 'Início',
        browse: 'Navegar',
        search: 'Pesquisar',
        channel: 'Canal do YouTube The Movie Matrix TV',
        past: 'O Passado',
        present: 'O Presente',
        future: 'O Futuro',
      },
      eras: {
        pastTitle: 'O Passado',
        pastSubtitle: 'Filmes mudos até os anos 70',
        presentTitle: 'O Presente',
        presentSubtitle: 'Dos anos 80 até os lançamentos de hoje',
        futureTitle: 'O Futuro',
        futureSubtitle: 'Próximos trailers e teasers "Em Breve"',
      },
      home: {
        slogan: 'O Passado, Presente e Futuro do Cinema',
        watchTrailer: 'Assistir Trailer',
        randomTrailer: 'Trailer Aleatório',
        trendingTitle: 'Tendências da Semana',
        trendingSubtitle: 'Os trailers mais quentes que todos estão assistindo',
        popularTitle: 'Favoritos de Todos os Tempos',
        popularSubtitle: 'Trailers clássicos que nunca envelhecem',
        loading: 'Carregando trailers...',
      },
      browse: {
        title: 'Navegar Trailers',
        subtitle: 'Filtrar por gênero, ano e popularidade',
        filters: 'Filtros',
        genre: 'Gênero',
        year: 'Ano',
        sortBy: 'Ordenar Por',
        allGenres: 'Todos os Gêneros',
        allYears: 'Todos os Anos',
        mostPopular: 'Mais Popular',
        leastPopular: 'Menos Popular',
        highestRated: 'Melhor Avaliado',
        lowestRated: 'Pior Avaliado',
        newest: 'Mais Recente',
        oldest: 'Mais Antigo',
        resetFilters: 'Redefinir Filtros',
        loading: 'Carregando filmes...',
        noMovies: 'Nenhum filme encontrado com estes filtros',
        previous: 'Anterior',
        next: 'Próximo',
        page: 'Página',
      },
      search: {
        title: 'Pesquisar Trailers',
        subtitle: 'Encontre qualquer trailer de qualquer época',
        placeholder: 'Pesquisar um filme...',
        searchButton: 'Pesquisar',
        searching: 'Pesquisando...',
        resultsFor: '{{count}} resultados para "{{query}}"',
        noResults: 'Nenhum filme encontrado para "{{query}}"',
        tryDifferent: 'Tente pesquisar com palavras-chave diferentes',
        startSearching: 'Comece a pesquisar para descobrir trailers',
      },
      movie: {
        loading: 'Carregando detalhes do filme...',
        notFound: 'Filme não encontrado',
        overview: 'Sinopse',
        watchTrailer: 'Assistir Trailer',
        moreTrailers: 'Mais Trailers',
        rating: 'Avaliação',
        year: 'Ano',
        runtime: 'min',
      },
    },
  },
  fr: {
    translation: {
      nav: {
        home: 'Accueil',
        browse: 'Parcourir',
        search: 'Rechercher',
        channel: 'Chaîne YouTube The Movie Matrix TV',
        past: 'Le Passé',
        present: 'Le Présent',
        future: 'Le Futur',
      },
      eras: {
        pastTitle: 'Le Passé',
        pastSubtitle: 'Films muets jusqu\'aux années 70',
        presentTitle: 'Le Présent',
        presentSubtitle: 'Des années 80 aux dernières sorties d\'aujourd\'hui',
        futureTitle: 'Le Futur',
        futureSubtitle: 'Bandes-annonces à venir et teasers "Prochainement"',
      },
      home: {
        slogan: 'Le Passé, le Présent et l\'Avenir du Cinéma',
        watchTrailer: 'Regarder la Bande-annonce',
        randomTrailer: 'Bande-annonce Aléatoire',
        trendingTitle: 'Tendances de la Semaine',
        trendingSubtitle: 'Les bandes-annonces les plus populaires',
        popularTitle: 'Favoris de Tous les Temps',
        popularSubtitle: 'Les bandes-annonces classiques qui ne vieillissent jamais',
        loading: 'Chargement des bandes-annonces...',
      },
      browse: {
        title: 'Parcourir les Bandes-annonces',
        subtitle: 'Filtrer par genre, année et popularité',
        filters: 'Filtres',
        genre: 'Genre',
        year: 'Année',
        sortBy: 'Trier Par',
        allGenres: 'Tous les Genres',
        allYears: 'Toutes les Années',
        mostPopular: 'Plus Populaire',
        leastPopular: 'Moins Populaire',
        highestRated: 'Mieux Noté',
        lowestRated: 'Moins Bien Noté',
        newest: 'Plus Récent',
        oldest: 'Plus Ancien',
        resetFilters: 'Réinitialiser les Filtres',
        loading: 'Chargement des films...',
        noMovies: 'Aucun film trouvé avec ces filtres',
        previous: 'Précédent',
        next: 'Suivant',
        page: 'Page',
      },
      search: {
        title: 'Rechercher des Bandes-annonces',
        subtitle: 'Trouvez n\'importe quelle bande-annonce de n\'importe quelle époque',
        placeholder: 'Rechercher un film...',
        searchButton: 'Rechercher',
        searching: 'Recherche...',
        resultsFor: '{{count}} résultats pour "{{query}}"',
        noResults: 'Aucun film trouvé pour "{{query}}"',
        tryDifferent: 'Essayez de rechercher avec des mots-clés différents',
        startSearching: 'Commencez à rechercher pour découvrir des bandes-annonces',
      },
      movie: {
        loading: 'Chargement des détails du film...',
        notFound: 'Film non trouvé',
        overview: 'Synopsis',
        watchTrailer: 'Regarder la Bande-annonce',
        moreTrailers: 'Plus de Bandes-annonces',
        rating: 'Note',
        year: 'Année',
        runtime: 'min',
      },
    },
  },
  de: {
    translation: {
      nav: {
        home: 'Startseite',
        browse: 'Durchsuchen',
        search: 'Suchen',
        channel: 'The Movie Matrix TV YouTube-Kanal',
        past: 'Die Vergangenheit',
        present: 'Die Gegenwart',
        future: 'Die Zukunft',
      },
      eras: {
        pastTitle: 'Die Vergangenheit',
        pastSubtitle: 'Stummfilme bis in die 1970er Jahre',
        presentTitle: 'Die Gegenwart',
        presentSubtitle: 'Die 80er bis zu den heutigen Neuerscheinungen',
        futureTitle: 'Die Zukunft',
        futureSubtitle: 'Kommende Trailer und "Demnächst"-Teaser',
      },
      home: {
        slogan: 'Die Vergangenheit, Gegenwart und Zukunft des Films',
        watchTrailer: 'Trailer Ansehen',
        randomTrailer: 'Zufälliger Trailer',
        trendingTitle: 'Trends dieser Woche',
        trendingSubtitle: 'Die heißesten Trailer, die jeder sieht',
        popularTitle: 'Zeitlose Favoriten',
        popularSubtitle: 'Klassische Trailer, die nie alt werden',
        loading: 'Trailer werden geladen...',
      },
      browse: {
        title: 'Trailer Durchsuchen',
        subtitle: 'Nach Genre, Jahr und Beliebtheit filtern',
        filters: 'Filter',
        genre: 'Genre',
        year: 'Jahr',
        sortBy: 'Sortieren Nach',
        allGenres: 'Alle Genres',
        allYears: 'Alle Jahre',
        mostPopular: 'Am Beliebtesten',
        leastPopular: 'Am Wenigsten Beliebt',
        highestRated: 'Am Besten Bewertet',
        lowestRated: 'Am Schlechtesten Bewertet',
        newest: 'Neueste',
        oldest: 'Älteste',
        resetFilters: 'Filter Zurücksetzen',
        loading: 'Filme werden geladen...',
        noMovies: 'Keine Filme mit diesen Filtern gefunden',
        previous: 'Zurück',
        next: 'Weiter',
        page: 'Seite',
      },
      search: {
        title: 'Trailer Suchen',
        subtitle: 'Finden Sie jeden Filmtrailer aus jeder Epoche',
        placeholder: 'Nach einem Film suchen...',
        searchButton: 'Suchen',
        searching: 'Suche läuft...',
        resultsFor: '{{count}} Ergebnisse für "{{query}}"',
        noResults: 'Keine Filme für "{{query}}" gefunden',
        tryDifferent: 'Versuchen Sie es mit anderen Suchbegriffen',
        startSearching: 'Beginnen Sie mit der Suche, um Trailer zu entdecken',
      },
      movie: {
        loading: 'Filmdetails werden geladen...',
        notFound: 'Film nicht gefunden',
        overview: 'Übersicht',
        watchTrailer: 'Trailer Ansehen',
        moreTrailers: 'Weitere Trailer',
        rating: 'Bewertung',
        year: 'Jahr',
        runtime: 'Min',
      },
    },
  },
  it: {
    translation: {
      nav: {
        home: 'Home',
        browse: 'Sfoglia',
        search: 'Cerca',
        channel: 'Canale YouTube The Movie Matrix TV',
        past: 'Il Passato',
        present: 'Il Presente',
        future: 'Il Futuro',
      },
      eras: {
        pastTitle: 'Il Passato',
        pastSubtitle: 'Film muti fino agli anni \'70',
        presentTitle: 'Il Presente',
        presentSubtitle: 'Dagli anni \'80 alle ultime uscite di oggi',
        futureTitle: 'Il Futuro',
        futureSubtitle: 'Trailer in arrivo e teaser "Prossimamente"',
      },
      home: {
        slogan: 'Il Passato, il Presente e il Futuro del Cinema',
        watchTrailer: 'Guarda il Trailer',
        randomTrailer: 'Trailer Casuale',
        trendingTitle: 'Tendenze della Settimana',
        trendingSubtitle: 'I trailer più popolari che tutti stanno guardando',
        popularTitle: 'Preferiti di Tutti i Tempi',
        popularSubtitle: 'Trailer classici che non invecchiano mai',
        loading: 'Caricamento trailer...',
      },
      browse: {
        title: 'Sfoglia Trailer',
        subtitle: 'Filtra per genere, anno e popolarità',
        filters: 'Filtri',
        genre: 'Genere',
        year: 'Anno',
        sortBy: 'Ordina Per',
        allGenres: 'Tutti i Generi',
        allYears: 'Tutti gli Anni',
        mostPopular: 'Più Popolare',
        leastPopular: 'Meno Popolare',
        highestRated: 'Più Votato',
        lowestRated: 'Meno Votato',
        newest: 'Più Recente',
        oldest: 'Più Vecchio',
        resetFilters: 'Reimposta Filtri',
        loading: 'Caricamento film...',
        noMovies: 'Nessun film trovato con questi filtri',
        previous: 'Precedente',
        next: 'Successivo',
        page: 'Pagina',
      },
      search: {
        title: 'Cerca Trailer',
        subtitle: 'Trova qualsiasi trailer di qualsiasi epoca',
        placeholder: 'Cerca un film...',
        searchButton: 'Cerca',
        searching: 'Ricerca in corso...',
        resultsFor: '{{count}} risultati per "{{query}}"',
        noResults: 'Nessun film trovato per "{{query}}"',
        tryDifferent: 'Prova a cercare con parole chiave diverse',
        startSearching: 'Inizia a cercare per scoprire i trailer',
      },
      movie: {
        loading: 'Caricamento dettagli film...',
        notFound: 'Film non trovato',
        overview: 'Trama',
        watchTrailer: 'Guarda il Trailer',
        moreTrailers: 'Altri Trailer',
        rating: 'Valutazione',
        year: 'Anno',
        runtime: 'min',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;